import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  BankOutlined,
  DeploymentUnitOutlined,
  DollarOutlined,
} from "@ant-design/icons";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  beforeUpload,
  queryHandler,
  uploadImages,
  UploadButton,
} from "../../lib/global_functions";
import {
  CreateDataById,
  GetDataListById,
  GetDataListFromServer,
} from "../../lib/api";
import {
  USER_BANK_LIST,
  USER_DEPOSIT_CREATE,
  CURRENCY_TYPE,
  AGENT_BANK_LIST,
  AGENT_LIST,
} from "../../lib/config";
import { GetDataFromServer } from "../../lib/api";
import { QUERY_AGENT_BANK } from "../../lib/query_obj";
import TextArea from "antd/es/input/TextArea";
import { setState } from "../../redux/user";

const { Text } = Typography;
export default function DepositModal({ closeDrawer, detail }) {
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(false);
  const [curType, setCurType] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [agentBankList, setAgentBankList] = useState([]);
  const [transactionError, setShowTransactionError] = useState(
    "Transaction ID must be 6 numbers"
  );

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });
  const [filter, setFilter] = useState({
    name: "",
    order_by: "created_at",
    order_type: "DESC",
  });

  async function getRefreshDataList() {
    await GetDataFromServer(AGENT_LIST, user.access_token)
      .then((res) => {
        dispatch(
          setState({
            ...user,
            points: res.data.points,
            total_deposit_points: res.data.total_deposit_points,
            total_withdraw_points: res.data.total_withdraw_points,
          })
        );
      })
      .catch((error) => {
        toast.error(error?.response.data || "Connection Error");
      });
  }

  async function getCurrencyData() {
    setLoading(true);
    await GetDataFromServer(CURRENCY_TYPE, user.access_token)
      .then(({ data: { data: res } }) => {
        setCurType(res);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  async function getUserBankData() {
    setLoading(true);
    await GetDataListById(USER_BANK_LIST, detail.id, user.access_token)
      .then(({ data: { data: res } }) => {
        setLoading(false);

        setBankList(res);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  async function getAgentBankData(page_number, per_page) {
    setLoading(true);
    await GetDataListFromServer(
      AGENT_BANK_LIST,
      queryHandler(filter, QUERY_AGENT_BANK, {page_number, per_page}),
      user.access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        const activeBanks = Array.isArray(res)
          ? res.filter((bank) => bank.is_active === true)
          : [];
        setAgentBankList(activeBanks);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }
  useEffect(() => {
    getCurrencyData();
    getUserBankData();
    getAgentBankData(pagin.page_number, pagin.per_page);
    getRefreshDataList();
  }, []);

  async function submitHandler(values) {
    setLoading(true);

    const formattedValues = {
      ...Object.fromEntries(
        Object.entries(values).map(([key, value]) => [
          key,
          typeof value === "number" ? value.toString() : value,
        ])
      ),
      image_url: imageUrl || "",
    };

    const apiCall = CreateDataById(
      USER_DEPOSIT_CREATE,
      detail.id,
      formattedValues,
      user.access_token,
      user.csrf_token
    );

    apiCall
      .then(() => {
        toast.success("Created deposit successfully");
        setLoading(false);
        closeDrawer(true);
        getRefreshDataList();
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.response.data.error || "Connection Error");
      });
  }

  function ValidateTransactionId(_, value) {
    if (!value) {
      return Promise.reject();
    }
    const idStr = value.toString();
    if (idStr.length !== 6) {
      setShowTransactionError("Transaction ID must be 6 numbers");
      return Promise.reject(new Error("Transaction ID must be 6 numbers"));
    }
    setShowTransactionError("");
    return Promise.resolve();
  }

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  };
  function renderBankOptions(value) {
    const iconPath = BANK_ICON_MAP[value.bank_type];
    const displayName = value.acc_name.length > 10 
    ? `${value.acc_name.substring(0, 10)}***` 
    : value.acc_name;

    return (
      <Row align="middle" gutter={8}>
        <Col>
          <img
            src={iconPath}
            alt={value.bank_type}
            style={{ width: 25, height: 25, verticalAlign: "middle", borderRadius:"5px" }}
          />
        </Col>
        <Col>
          <Space size={4}>
            <Text>{displayName}</Text>
            <Text type="secondary">-</Text>
            <Text type="secondary">{value.bank_type.replace(/_/g, " ")}</Text>
          </Space>
        </Col>
      </Row>
    );
  }

  function renderAgentBankOptions(value) {
    const iconPath = BANK_ICON_MAP[value.bank_type];
    const displayName = value.acc_name.length > 10 
    ? `${value.acc_name.substring(0, 10)}***` 
    : value.acc_name;

    return (
      <Row align="middle" gutter={8}>
        <Col>
          <img
            src={iconPath}
            alt={value.bank_type}
            style={{ width: 25, height: 25, verticalAlign: "middle", borderRadius:"5px" }}
          />
        </Col>
        <Col>
          <Space size={4}>
            <Text>{displayName}</Text>
            <Text type="secondary">-</Text>
            <Text type="secondary">{value.bank_type.replace(/_/g, " ")}</Text>
          </Space>
        </Col>
      </Row>
    );
  }

  return (
    <Form
      size={user.ui_size}
      form={form}
      onFinish={submitHandler}
      layout="vertical"
    >
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Transaction ID"
            name="bank_transaction_id"
            rules={[{ required: true }, { validator: ValidateTransactionId }]}
            help={transactionError}
            validateStatus={transactionError ? "warning" : ""}
            hasFeedback
          >
            <Input
              prefix={<DollarOutlined style={{ marginRight: "8px" }} />}
              controls={false}
              placeholder="Transaction ID"
              maxLength={6}
              style={{
                width: "100%",
                ...(transactionError === "warning"
                  ? { borderColor: "#faad14" }
                  : {}),
              }}
              onBeforeInput={(e) => {
                if (!/^[a-zA-Z0-9]$/.test(e.data)) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Amount" name="amount" rules={[{ required: true }]}>
            <InputNumber
              prefix={<DollarOutlined style={{ marginRight: "8px" }} />}
              controls={false}
              placeholder="Amount"
              type="number"
              style={{ width: "100%" }}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "+" ||
                  e.key === "-"
                ) {
                  e.preventDefault();
                }
              }}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Currency"
            name="currency"
            rules={[{ required: true }]}
          >
            <Select
              loading={loading}
              placeholder={
                <span>
                  <DeploymentUnitOutlined style={{ marginRight: 8 }} />
                  Select Currency Type
                </span>
              }
              options={curType.map((value) => ({
                label: value,
                value: value,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="User Bank Account"
            name="user_bank_account_id"
            rules={[{ required: true }]}
          >
            <Select
              loading={loading}
              placeholder={
                <span>
                  <BankOutlined style={{ marginRight: 8 }} />
                  Select User Bank
                </span>
              }
              options={bankList.map((value) => ({
                label: renderBankOptions(value),
                value: value.id,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item
            label="Agent Bank Account"
            name="agent_bank_account_id"
            rules={[{ required: true }]}
          >
            <Select
              placeholder={
                <span>
                  <BankOutlined style={{ marginRight: 8 }} />
                  Select Agent Bank
                </span>
              }
              options={agentBankList.map((value) => ({
                label: renderAgentBankOptions(value),
                value: value.id,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <Form.Item name="note" label="Note">
            <TextArea rows={4} placeholder="Note" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="image_url" label="Image">
            <Upload
              name="image_url"
              accept=".jpg,.jpeg,.png"
              listType="picture-card"
              showUploadList={false}
              style={{ height: "200px", width: "200px" }}
              customRequest={(option) =>
                uploadImages({
                  ...option,
                  access_token: user.access_token,
                  csrf_token: user.csrf_token,
                  folder_name: "UI_IMAGES",
                  image: imageUrl,
                  setImage: setImageUrl,
                })
              }
              beforeUpload={(file) => beforeUpload(file, 1)}
              isImageUrl={true}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  style={{
                    objectFit: "contain",
                    objectPosition: "center",
                    height: "100px",
                    width: "100px",
                  }}
                />
              ) : (
                UploadButton(loading)
              )}
            </Upload>
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24} align="right">
          <Button type="primary" htmlType="submit" loading={loading}>
            Create
          </Button>
          <Button
            onClick={() => closeDrawer(false)}
            style={{ marginLeft: "12px", marginTop: "15px" }}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
